<app-menu class="over-three"></app-menu>
<app-side-left class="over-three"></app-side-left>
<app-attribute-display *ngIf="model.generalSettings.showAttributeInfo" class="over-three"></app-attribute-display>

<!-- <div class="over-three right-buttom">
    <button mat-icon-button  (click)="openChat()" class="example-icon" aria-label="start chat">
        <mat-icon>chat_bubble</mat-icon>
    </button>
</div> -->
<app-three></app-three>
